export function suffixId(id, suffix) {
    if (typeof id === 'string')
        return `${id}--${suffix}`;
    return;
}
//# sourceMappingURL=suffixId.js.map